import { Form, Select } from 'antd';
import { yearOptions } from '../policies/catalogue-options';

/** Model year, chosen from newest (next year, the latest the server accepts) down to 1980. A stored year outside that stays selectable. */
export function TruckYearField() {
  const year = Form.useWatch<number | undefined>('year');

  return (
    <Form.Item name="year" label="Year" rules={[{ required: true, message: 'Select a year' }]}>
      <Select options={yearOptions(year)} showSearch optionFilterProp="label" placeholder="Select a year" />
    </Form.Item>
  );
}
